import { themeVars } from '@styles/themes.css';
import { FC } from 'react';

interface Props {
  className?: string;
}

const ArrowBackground: FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox='0 0 473 695'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M90.5152 651.806L84.3371 693.855L90.5152 651.806ZM153.26 205.34C136.24 221.504 135.547 248.405 151.711 265.424C167.875 282.444 194.775 283.137 211.795 266.973L153.26 205.34ZM387.764 326.489C389.791 349.873 410.391 367.187 433.775 365.16C457.16 363.134 474.473 342.534 472.447 319.149L387.764 326.489ZM381.753 46.9464L352.485 16.1298L381.753 46.9464ZM-122.511 379.196C-73.0746 347.404 -38.0901 329.497 -14.0085 321.044C12.1106 311.874 15.4773 317.274 10.8755 314.603C4.36231 310.822 7.9523 306.54 8.99158 321.784C9.94474 335.765 7.88022 355.658 3.53098 381.85C-4.41412 429.697 -20.7089 499.004 -20.2712 554.52C-20.046 583.076 -15.6631 614.617 0.697132 641.309C18.4486 670.271 47.0926 688.382 84.3371 693.855L96.6934 609.757C81.7011 607.555 76.4009 602.165 73.1674 596.89C68.5427 589.345 64.9001 575.913 64.7262 553.85C64.3657 508.128 77.7785 453.613 87.3828 395.774C91.8083 369.123 95.4789 340.707 93.7947 316.003C92.1967 292.562 84.7768 259.219 53.5483 241.091C24.2311 224.073 -10.823 229.84 -42.1632 240.842C-75.5408 252.559 -117.054 274.628 -168.487 307.704L-122.511 379.196ZM84.3371 693.855C113.994 698.212 138.05 681.683 152.741 668.521C168.933 654.014 184.343 634.091 198.692 612.354C227.642 568.499 257.617 508.956 285.577 446.966C341.733 322.462 392.871 181.045 414.934 117.725L334.667 89.7574C312.858 152.351 262.692 290.967 208.094 412.018C180.676 472.804 152.911 527.418 127.754 565.527C115.05 584.772 104.317 597.781 96.0222 605.212C86.2281 613.987 87.456 608.4 96.6934 609.757L84.3371 693.855ZM211.795 266.973L411.02 77.763L352.485 16.1298L153.26 205.34L211.795 266.973ZM364.685 60.1973L387.764 326.489L472.447 319.149L449.367 52.858L364.685 60.1973ZM411.02 77.763C394.315 93.6286 366.674 83.1501 364.685 60.1973L449.367 52.858C445.208 4.86584 387.414 -17.0438 352.485 16.1298L411.02 77.763Z'
        fill='url(#paint0_linear_1203_2684)'
        fillOpacity='0.6'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1203_2684'
          x1='424.317'
          y1='-49.374'
          x2='-99.2704'
          y2='328.285'
          gradientUnits='userSpaceOnUse'
        >
          <stop
            stopColor={themeVars.brandColor.presentation.arrow.gradientStart}
            stopOpacity='0.3'
          />
          <stop
            offset='1'
            stopColor={themeVars.brandColor.presentation.arrow.gradientEnd}
            stopOpacity='0.7'
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ArrowBackground;
